import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {DashboardService} from "../../../dashboard/services/dashboard.service";
import {Utils} from "../../Utils";

declare var $: any;

@Component({
  selector: 'app-map-temperature-departure-from-normal',
  templateUrl: './map-temperature-departure-from-normal.component.html',
  styleUrls: ['./map-temperature-departure-from-normal.component.less']
})
export class MapTemperatureDepartureFromNormalComponent implements OnInit, OnDestroy {

  _map:any;
  subscription:any;
  data:any;
  currentDate:Date;
  mappedData:any;
  tooltipText: string;
  @Input() mapId;
  @Input() mapTitle;
  @Input() dataSet: string; // either 'departure' or 'weekly change'
    @Input() legend: any;
    // heatMapColors = [
    //     {color : '#003c56', label : "<= -20" , topLabel : '°F below normal', upper: "<= -20", lower: ""},
    //     {color : '#006997', label : "-19 - -15" ,lower: "-19", upper: "-15" },
    //     {color : '#0096d7', label : "-14 to -10",lower: "-14", upper: "-10" },
    //     {color : '#4db6e3', label : "-9 to -5",lower: "-9", upper: "-5" },
    //     {color : '#99d5ef', label : "-4 to -1" ,lower: "-4", upper: "-1"},
    //     {color : '#AFAFAF', label : "0" , topLabel : 'normal', lower: '', upper: '0' },
    //     {color : '#e5c799', label : "1 to 5" ,lower: "1", upper: "4"},
    //     {color : '#d19d69', label : "6 to 10" ,lower: "5", upper: "9"},
    //     {color : '#bd732a', label : "11 to 15" ,lower: "10", upper: "14"},
    //     {color : '#84511d', label : "16 to 19" ,lower: "15", upper: "19"},
    //     {color : '#4c2e11', label : ">= 20" , topLabel : '°F above normal' ,lower: ">= 20", upper: ""}
    // ];
  constructor(private dashboardService: DashboardService) { }

  ngOnInit() {


    //If  norm do one thing, if not do other
      if (this.dataSet == 'departure'){
          this.subscription = this.dashboardService.getTemperatureDepartureByClimateDivision().subscribe(
              json =>{
                  this.data = json;
          }, null, ()=>{
                  this.tooltipText = ' change from 30yr normal';
                this.setupMap();
              }
          )
      }
      else {
          this.dashboardService.getTemperatureDepartureFromPriorWeek().subscribe(
              json =>{
                  this.data = json;
              }, null, ()=>{
                  this.tooltipText = ' change from prior week';
                  this.setupMap();
              }
          )
      }
  }

  ngAfterViewInit() {

  }
  private setupMap(){
      let that = this;
      this.mappedData = {};

      //Current Date
      this.currentDate =
          this.currentDate = Utils.oracleDateStringToDate(this.data.date);

      for(var code in this.data.data) {
          var temperature = +this.data.data[code];
          switch(true){
              case temperature <= -20:
                  this.mappedData[code] = "1";
                  break;
              case temperature <= -15:
                  this.mappedData[code] = "2";
                  break;
              case temperature <= -10:
                  this.mappedData[code] = "3";
                  break;
              case temperature <= -5:
                  this.mappedData[code] = "4";
                  break;
              case temperature < 0:
                  this.mappedData[code] = "5";
                  break;
              case temperature == 0:
                  this.mappedData[code] = "6";
                  break;
              case temperature <= 5:
                  this.mappedData[code] = "7";
                  break;
              case temperature <= 10:
                  this.mappedData[code] = "8";
                  break;
              case temperature <= 15:
                  this.mappedData[code] = "9";
                  break;
              case temperature <= 20:
                  this.mappedData[code] = "10";
                  break;
              default :
                  this.mappedData[code] = "11"
                  break;
          }
      }
      let map = $('#' + this.mapId).vectorMap({
          map: 'climate-divisions_aea_en',
          backgroundColor: '#ffffff',
          series: {
              regions: [{
                  values: this.mappedData,
                  attribute : 'fill',
                  scale: {
                      "1":"#003c56",
                      "2":"#006997",
                      "3":"#0096d7",
                      "4":"#4db6e3",
                      "5":"#99d5ef",
                      "6":"#afafaf",
                      "7":"#e5c7aa",
                      "8":"#d19d69",
                      "9":"#bd732a",
                      "10":"#84511d",
                      "11":"#4c2e11"
                  }
              }]
          },
          onRegionLabelShow: function(e, el, code){
              let currentRegName = el.html().toLowerCase().split(", ");
              let stateRegName = currentRegName[1].toUpperCase();
              currentRegName[1] = " " + stateRegName;

              el.html('<span class="regionTitle">' + currentRegName + '</span>' + ' : ' + that.data.data[code] + ' &#x2109;' + that.tooltipText);
          }
      });
      this._map = map.vectorMap('get', 'mapObject');

      // render lines for storage regions
      let storageRegionsPath = document.createElementNS(this._map.canvas.rootElement.node.namespaceURI, "path");
      storageRegionsPath.setAttributeNS(null, 'd', this._map.mapData.storagePath);
      storageRegionsPath.setAttributeNS(null, 'fill', 'none');
      storageRegionsPath.setAttributeNS(null, 'stroke', 'white');
      storageRegionsPath.setAttributeNS(null, 'stroke-width', "5");

      this._map.canvas.rootElement.node.appendChild(storageRegionsPath);
  }

  ngOnDestroy() {
      if (this.subscription) {
          this.subscription.unsubscribe();
          if (this._map !== undefined) {
              this._map.remove();
              this._map = undefined;
          }
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/map-temperature-departure-from-normal/map-temperature-departure-from-normal.component.ts